// extracted by mini-css-extract-plugin
export default {"container":"animated-header_container__QKmw4"};